import { render, staticRenderFns } from "./video-chunk-slider.vue?vue&type=template&id=11fd0940&scoped=true"
import script from "./video-chunk-slider.vue?vue&type=script&lang=js"
export * from "./video-chunk-slider.vue?vue&type=script&lang=js"
import style0 from "./video-chunk-slider.vue?vue&type=style&index=0&id=11fd0940&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11fd0940",
  null
  
)

export default component.exports